import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ContainerLookupModel } from 'app/generated/backend/shipment/api/container-lookup-model';

@Injectable()
export class ContainerLookupHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	get(
		containerSize: number
	): Observable<JsonResourceResponse<ContainerLookupModel>> {
		return this.http.get<JsonResourceResponse<ContainerLookupModel>>(`api/v1/shipment/containerLookup/${containerSize}`).pipe(
			map(response => response),
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		ContainerLookupHandlerService
	]
})
export class ContainerLookupHandlerModule { }
